<template>
    <li class="ejs-item">
        <span v-html="adjustContent(item.content)"/>
        <template v-if="item.items && item.items.length">
            <ol v-if="type === 'ol'">
                <ejs-list-item v-if="item.items.length" v-for="i in item.items" :item="i" :type="type"/>
            </ol>
            <ul v-else>
                <ejs-list-item v-if="item.items.length" v-for="i in item.items" :item="i" :type="type"/>
            </ul>
        </template>
    </li>
</template>

<script>
    export default {
        name: 'EjsListItem',
        props: {
            item: {
                type: Object
            },
            type: {
                type: String
            }
        },
        data: function() {
            return {

            }
        },
        methods: {
            adjustContent(content) {
                return content.replace(/href=/gi, "target='_blank' href=");
            }
        }
    }
</script>

<style lang="scss" scoped>
    li {

    }
</style>
